<div class="mt-3">
  <div class="d-flex flex-column gap-2">
    @for (batch of ticketBatches; track batch; let batchIndex = $index) {
      <div class="card">
        <div class="card-body p-3">
          @if (!singleTicketMode) {
            <div>
              <div class="container-header-lote">
                <div class="d-flex gap-2 align-content-center flex-wrap mb-2">
                  <app-button styleType="secondary">Lote {{ batch.sequence_number ?? batchIndex + 1 }}</app-button>
                  @if (batch.pdv_only) {
                    <span class="badge align-self-center">Portaria</span>
                  }
                  @if (batch.has_half_price) {
                    <span class="badge align-self-center">Meia-entrada</span>
                  }
                  @if (batch.transition_closed_at) {
                    <span class="badge bg-secondary text-white align-self-center" role="status">Lote encerrado</span>
                  } @else {
                    <app-button icon="pi pi-pen-to-square" styleType="outlined" (btnClick)="editBatch(batch)">
                      Editar lote
                    </app-button>
                    @if (
                      management &&
                      batch.id &&
                      batch.can_transition &&
                      batch.next_batch_number !== null &&
                      batch.next_batch_number !== undefined
                    ) {
                      <app-button
                        data-testid="transition-batch"
                        icon="pi pi-forward"
                        styleType="outlined"
                        [disabled]="transitionPending || !!transitionDisabledReason"
                        (btnClick)="requestTransition(batch)">
                        Virar para o próximo lote
                      </app-button>
                    }
                  }
                  @if (canDeleteBatch(batch)) {
                    <app-button icon="pi pi-trash" styleType="clean" (click)="deleteBatch(batchIndex)">
                      Excluir lote
                    </app-button>
                  }
                </div>
                @if (canEditBatch(batch)) {
                  <div class="mb-2">
                    <app-button icon="pi pi-plus" styleType="primary" (btnClick)="newTicket(batchIndex)">
                      Novo ingresso
                    </app-button>
                  </div>
                }
              </div>
              @if (management && batch.id && !batch.transition_closed_at) {
                @if (batch.can_transition && transitionDisabledReason) {
                  <p class="p text-secondary">{{ transitionDisabledReason }}</p>
                } @else if (batch.transition_block_reason) {
                  <p class="p text-secondary">{{ batch.transition_block_reason }}</p>
                }
              }
              <div class="d-flex gap-2">
                <div>
                  @if (batch.id) {
                    <p class="p text-secondary">#{{ batch.id }}</p>
                  }
                  <div class="d-flex align-items-center gap-2" title="Início das vendas">
                    <p class="p" style="font-weight: bold">Início das vendas</p>
                    <p class="p text-secondary">
                      {{ batch.sale_start ? (batch.sale_start | date: "short") : "Aguarda o lote anterior" }}
                    </p>
                  </div>
                  <div class="d-flex align-items-center gap-2" title="Fim das vendas">
                    <p class="p" style="font-weight: bold">Fim das vendas</p>
                    <p class="p text-secondary">
                      @if (batch.transition_closed_at) {
                        Encerrado em {{ batch.transition_closed_at | date: "short" }}
                      } @else {
                        {{
                          batch.transition_mode === "sold_out_only"
                            ? (batch.pdv_only ? "Até esgotar ou até o fim do evento" : "Até esgotar ou até o início do evento")
                            : (batch.sale_end | date: "short")
                        }}
                      }
                    </p>
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="container-ingressos">
            @for (ticket of batch.tickets; track $index) {
              <div class="card card-ingresso">
                <div class="card-body p-2 d-flex flex-column justify-content-between">
                  <div class="p-2">
                    <div class="ticket-heading">
                      <p class="h6 ticket-title">{{ getTicketDisplayTitle(ticket) }}</p>
                      @if (ticket.half_price) {
                        <span class="badge ticket-half-price">Meia-entrada</span>
                      }
                      @if (ticket.id) {
                        <p class="p text-secondary m-0">#{{ ticket.id }}</p>
                      }
                    </div>
                    <p class="p text-secondary ticket-description">{{ ticket.description }}</p>
                    <div class="d-flex align-items-center justify-content-between w-100">
                      <p class="p" style="font-weight: bold">Valor final</p>
                      <p class="p text-secondary">
                        {{ getFinalPriceString(ticket.price, batch.pdv_only || batch.absorbs_platform_fee) | currency: "BRL" }}
                      </p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between w-100" title="Quantidade disponível">
                      <p class="p" style="font-weight: bold">Quantidade</p>
                      <p class="p text-secondary">{{ ticket.quantity }}</p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between w-100" title="Limite por comprador">
                      <p class="p" style="font-weight: bold">Limite</p>
                      <p class="p text-secondary">{{ ticket.min_per_buyer }} - {{ ticket.max_per_buyer }}</p>
                    </div>
                  </div>
                  @if (canEditBatch(batch) || canTransitionTicket(batch, ticket)) {
                    <div class="d-flex w-100 flex-column align-items-center gap-1">
                      <div class="d-flex w-100 align-items-center justify-content-center flex-wrap">
                        @if (canEditBatch(batch)) {
                          <app-button
                            title="Editar ingresso"
                            icon="pi pi-pen-to-square"
                            styleType="clean"
                            style="padding: 0"
                            (btnClick)="editTicket(batchIndex, $index)">
                            Editar
                          </app-button>
                          @if (canDeleteTicket(ticket, batch)) {
                            <app-button
                              title="Remover ingresso"
                              icon="pi pi-trash"
                              styleType="clean"
                              style="padding: 0"
                              (click)="deleteTicket(batchIndex, $index)">
                              Excluir
                            </app-button>
                          }
                        }
                        @if (canTransitionTicket(batch, ticket)) {
                          <app-button
                            data-testid="transition-ticket"
                            title="Virar este ingresso para o próximo lote"
                            icon="pi pi-forward"
                            styleType="outlined"
                            [disabled]="transitionPending || !!transitionDisabledReason"
                            (btnClick)="requestTicketTransition(batch, ticket)">
                            Virar ingresso
                          </app-button>
                        }
                      </div>
                      @if (
                        management &&
                        batch.id &&
                        ticket.id &&
                        !ticket.transition_closed_at &&
                        ticketTransition(batch, ticket)?.transition_block_reason &&
                        !canTransitionTicket(batch, ticket)
                      ) {
                        <p class="p text-secondary m-0 text-center ticket-transition-reason">
                          {{ ticketTransition(batch, ticket)?.transition_block_reason }}
                        </p>
                      }
                    </div>
                  }
                </div>
              </div>
            } @empty {
              <p class="p text-secondary">Sem ingressos.</p>
            }
          </div>
        </div>
      </div>
    }

    @if (singleTicketMode) {
      @if (ticketBatches.length > 0 && ticketBatches[0]) {
        <div class="p-3 d-flex flex-wrap align-items-center justify-content-between gap-2">
          <div class="d-flex flex-column">
            <p class="p m-0" style="font-weight: bold">Disponibilização dos ingressos</p>
            <p class="p text-secondary m-0">
              {{ ticketBatches[0].sale_start | date: "short" }} até {{ ticketBatches[0].sale_end | date: "short" }}
            </p>
          </div>
          @if (canEditBatch(ticketBatches[0])) {
            <app-button icon="pi pi-pen-to-square" styleType="outlined" (btnClick)="editAvailabilityClick.emit()">
              Editar disponibilização
            </app-button>
          } @else {
            <span class="badge bg-secondary text-white" role="status">Lote encerrado</span>
          }
          @if (canDeleteBatch(ticketBatches[0])) {
            <app-button icon="pi pi-trash" styleType="clean" (click)="deleteBatch(0)"> Excluir lote </app-button>
          }
        </div>
      }
      @if (!hasAnyTicket) {
        <div class="p-3">
          <app-button icon="pi pi-plus" styleType="primary" (click)="createSingleTicketClick.emit()">
            Criar ingresso
          </app-button>
        </div>
      }
    } @else {
      <div class="p-3">
        <app-button icon="pi pi-plus" styleType="secondary" (click)="newBatch()">Novo lote</app-button>
      </div>
    }
  </div>
</div>
